// Ảnh đăng trên Facebook (Facebook chỉ đăng hình ảnh).
// url: dán link bài Facebook tương ứng vào đây; để trống thì không hiện nút "Xem bài trên Facebook".
export const photos = [
  {
    id: 1,
    title: 'Làng bánh tráng Cù lao Mây (Vĩnh Long)',
    src: '/BanhTrang.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/18ZtkKadhQ/',
  },
  {
    id: 2,
    title: 'Làng bánh tráng Cù lao Mây (Vĩnh Long)',
    src: '/BanhTrang2.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/18ZtkKadhQ/',
  },
  {
    id: 3,
    title: 'Làng bánh tráng Cù lao Mây (Vĩnh Long)',
    src: '/BanhTrang3.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/18ZtkKadhQ/',
  },
  {
    id: 4,
    title: 'Làng bánh tráng Cù lao Mây (Vĩnh Long)',
    src: '/BanhTrang4.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/18ZtkKadhQ/',
  },
  {
    id: 5,
    title: 'Làng bánh tráng Cù lao Mây (Vĩnh Long)',
    src: '/BanhTrang5.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/18ZtkKadhQ/',
  },
  {
    id: 6,
    title: 'Làng bánh tráng Cù lao Mây (Vĩnh Long)',
    src: '/BanhTrang6.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/18ZtkKadhQ/',
  },
  {
    id: 7,
    title: 'Làng bánh tráng Cù lao Mây (Vĩnh Long)',
    src: '/BanhTrang7.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/18ZtkKadhQ/',
  },
  {
    id: 8,
    title: 'Làng nghề tơ lụa Tân Châu (An Giang)',
    src: '/ToLua.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1C5gw8pbYA/',
  },
  {
    id: 9,
    title: 'Làng nghề tơ lụa Tân Châu (An Giang)',
    src: '/ToLua2.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1C5gw8pbYA/',
  },
  {
    id: 10,
    title: 'Làng nghề tơ lụa Tân Châu (An Giang)',
    src: '/ToLua3.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1C5gw8pbYA/',
  },
  {
    id: 11,
    title: 'Làng nghề tơ lụa Tân Châu (An Giang)',
    src: '/ToLua4.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1C5gw8pbYA/',
  },
  {
    id: 12,
    title: 'Làng nghề tơ lụa Tân Châu (An Giang)',
    src: '/ToLua5.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1C5gw8pbYA/',
  },
  {
    id: 13,
    title: 'Làng dệt thổ cẩm Chăm Châu Phong (An Giang)',
    src: '/TC1.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1ChziKawvp/',
  },
  {
    id: 14,
    title: 'Làng dệt thổ cẩm Chăm Châu Phong (An Giang)',
    src: '/TC2.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1ChziKawvp/',
  },
  {
    id: 15,
    title: 'Làng dệt thổ cẩm Chăm Châu Phong (An Giang)',
    src: '/TC3.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1ChziKawvp/',
  },
  {
    id: 16,
    title: 'Làng dệt thổ cẩm Chăm Châu Phong (An Giang)',
    src: '/TC4.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1ChziKawvp/',
  },
  {
    id: 17,
    title: 'Làng dệt thổ cẩm Chăm Châu Phong (An Giang)',
    src: '/TC5.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1ChziKawvp/',
  },
  {
    id: 18,
    title: 'Làng gạch Mang Thít (Vĩnh Long)',
    src: '/Gach1.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1DxNzyfGm5/',
  },
  {
    id: 19,
    title: 'Làng gạch Mang Thít (Vĩnh Long)',
    src: '/Gach2.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1DxNzyfGm5/',
  },
  {
    id: 20,
    title: 'Làng gạch Mang Thít (Vĩnh Long)',
    src: '/Gach3.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1DxNzyfGm5/',
  },
  {
    id: 21,
    title: 'Làng gạch Mang Thít (Vĩnh Long)',
    src: '/Gach4.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1DxNzyfGm5/',
  },
  {
    id: 22,
    title: 'Làng gạch Mang Thít (Vĩnh Long)',
    src: '/Gach5.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1DxNzyfGm5/',
  },
  {
    id: 23,
    title: 'Làng gạch Mang Thít (Vĩnh Long)',
    src: '/Gach6.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1DxNzyfGm5/',
  },
  {
    id: 24,
    title: 'Làng gạch Mang Thít (Vĩnh Long)',
    src: '/Gach7.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1DxNzyfGm5/',
  },
  {
    id: 25,
    title: 'Làng gạch Mang Thít (Vĩnh Long)',
    src: '/Gach8.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1DxNzyfGm5/',
  },
  {
    id: 26,
    title: 'Ghe tàu sông nước',
    src: '/Ghe1.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1L6hBqi4Yd/',
  },
  {
    id: 27,
    title: 'Ghe tàu sông nước',
    src: '/Ghe2.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1L6hBqi4Yd/',
  },
  {
    id: 28,
    title: 'Ghe tàu sông nước',
    src: '/Ghe3.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1L6hBqi4Yd/',
  },
  {
    id: 29,
    title: 'Ghe tàu sông nước',
    src: '/Ghe4.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1L6hBqi4Yd/',
  },
  {
    id: 30,
    title: 'Ghe tàu sông nước',
    src: '/Ghe5.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1L6hBqi4Yd/',
  },
  {
    id: 31,
    title: 'Ghe tàu sông nước',
    src: '/Ghe6.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1L6hBqi4Yd/',
  },
  {
    id: 32,
    title: 'Ghe tàu sông nước',
    src: '/Ghe7.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1L6hBqi4Yd/',
  },
  {
    id: 33,
    title: 'Ghe tàu sông nước',
    src: '/Ghe8.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1L6hBqi4Yd/',
  },
  {
    id: 34,
    title: 'Làng nghề đan đát (Sóc Trăng)',
    src: '/dan1.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1FBnDhvVC1/',
  },
  {
    id: 35,
    title: 'Làng nghề đan đát (Sóc Trăng)',
    src: '/dan2.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1FBnDhvVC1/',
  },
  {
    id: 36,
    title: 'Làng nghề đan đát (Sóc Trăng)',
    src: '/dan3.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1FBnDhvVC1/',
  },
  {
    id: 37,
    title: 'Làng nghề đan đát (Sóc Trăng)',
    src: '/dan4.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1FBnDhvVC1/',
  },
  {
    id: 38,
    title: 'Làng nghề đan đát (Sóc Trăng)',
    src: '/dan5.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1FBnDhvVC1/',
  },
  {
    id: 39,
    title: 'Đờn ca tài tử (Bạc Liêu)',
    src: '/don1.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1XiGfH8HHF/',
  },
  {
    id: 40,
    title: 'Đờn ca tài tử (Bạc Liêu)',
    src: '/don2.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1XiGfH8HHF/',
  },
  {
    id: 41,
    title: 'Đờn ca tài tử (Bạc Liêu)',
    src: '/don3.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1XiGfH8HHF/',
  },
  {
    id: 42,
    title: 'Đờn ca tài tử (Bạc Liêu)',
    src: '/don4.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1XiGfH8HHF/',
  },
  {
    id: 43,
    title: 'Đờn ca tài tử (Bạc Liêu)',
    src: '/don5.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1XiGfH8HHF/',
  },
  {
    id: 44,
    title: 'Đờn ca tài tử (Bạc Liêu)',
    src: '/don6.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1XiGfH8HHF/',
  },
  {
    id: 45,
    title: 'Đám giỗ miền Tây',
    src: '/gio1.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1SKRs3CVrz/',
  },
  {
    id: 46,
    title: 'Đám giỗ miền Tây',
    src: '/gio2.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1SKRs3CVrz/',
  },
  {
    id: 47,
    title: 'Đám giỗ miền Tây',
    src: '/gio3.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1SKRs3CVrz/',
  },
  {
    id: 48,
    title: 'Đám giỗ miền Tây',
    src: '/gio4.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1SKRs3CVrz/',
  },
  {
    id: 49,
    title: 'Đám giỗ miền Tây',
    src: '/gio5.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1SKRs3CVrz/',
  },
  {
    id: 50,
    title: 'Đám giỗ miền Tây',
    src: '/gio6.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1SKRs3CVrz/',
  },
  {
    id: 51,
    title: 'Đám giỗ miền Tây',
    src: '/gio7.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1SKRs3CVrz/',
  },
  {
    id: 52,
    title: 'Đám giỗ miền Tây',
    src: '/gio8.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1SKRs3CVrz/',
  },
  {
    id: 53,
    title: 'Đám giỗ miền Tây',
    src: '/gio9.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1SKRs3CVrz/',
  },
  {
    id: 54,
    title: 'Đám giỗ miền Tây',
    src: '/gio10.png',
    platform: 'Facebook',
    url: 'https://www.facebook.com/share/p/1SKRs3CVrz/',
  },
];
